module.exports = __webpack_public_path__ + "static/img/Paul-Sironen.8351efb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Paul-Sironen.jpg
// module id = qmq/
// module chunks = 0